/* +one · You Are Not Alone — movimiento de la home (revelados, contadores, parallax y franja) */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('y-motion')) return;
  window.__yMotion = true;

  const SCOPE = '.y:not(.y-hero):not(.y-foot):not(.y-pb)';
  const WORDS = ['.y-h2', '.y-quote'];
  const ITEMS = [
    '.y-eyebrow', '.y-lead', '.y-body', '.y-msg__intro', '.y-why__rule', '.y-stat', '.y-why__source',
    '.y-why__img', '.y-card', '.y-packcard', '.y-coll__head .y-link', '.y-tabs', '.y-strip',
    '.y-pcard', '.y-edcard__img', '.y-ed__author', '.y-actions', '.y-ed__nav',
    '.y-bank__img', '.y-bank__logo',
  ];
  const STEP = 110;
  const qsa = (el, s) => Array.from(el.querySelectorAll(s));

  /* ---- Partir un titular en palabras con máscara (respeta etiquetas internas) ---- */
  function splitWords(el) {
    if (el.dataset.ySplit) return;
    el.dataset.ySplit = '1';
    let i = 0;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const parts = node.nodeValue.split(/(\s+)/);
      if (parts.every((p) => !p.trim())) return;
      const frag = document.createDocumentFragment();
      parts.forEach((p) => {
        if (!p) return;
        if (!p.trim()) {
          frag.appendChild(document.createTextNode(p));
          return;
        }
        const w = document.createElement('span');
        w.className = 'y-w';
        const inner = document.createElement('span');
        inner.style.setProperty('--i', i++);
        inner.textContent = p;
        w.appendChild(inner);
        frag.appendChild(w);
      });
      node.parentNode.replaceChild(frag, node);
    });
  }

  /* ---- Contador para cifras con decimales o % ---- */
  function countUp(el, wait) {
    const raw = el.textContent.trim();
    const m = raw.match(/^(\D*)(\d+(?:[.,]\d+)?)(.*)$/);
    if (!m || !/[%,.]/.test(raw)) return;
    const [, pre, num, post] = m;
    const sep = num.includes(',') ? ',' : '.';
    const dec = (num.split(/[.,]/)[1] || '').length;
    const target = parseFloat(num.replace(',', '.'));
    const t0 = performance.now() + (wait || 0);
    const dur = 1600;
    const fmt = (v) => v.toFixed(dec).replace('.', sep);
    el.textContent = pre + fmt(0) + post;
    const tick = (t) => {
      const k = Math.max(0, Math.min(1, (t - t0) / dur));
      const e = 1 - Math.pow(1 - k, 4);
      el.textContent = pre + fmt(target * e) + post;
      if (k < 1) requestAnimationFrame(tick);
      else el.textContent = raw;
    };
    requestAnimationFrame(tick);
  }

  /* ---- Revelado ---- */
  function reveal(el, delay) {
    el.style.setProperty('--d', `${delay}ms`);
    el.classList.add('is-in');
    if (el.classList.contains('y-stat')) {
      const n = el.querySelector('.y-stat__n');
      if (n && !n.dataset.yCounted) {
        n.dataset.yCounted = '1';
        countUp(n, delay + 200);
      }
    }
  }

  // Los elementos recortados con clip-path no cuentan como visibles: se vigila su contenedor
  const CLIPPED = '.y-why__img, .y-edcard__img, .y-bank__img';
  const proxies = new Map();
  const watch = (el) => {
    if (!el.matches(CLIPPED)) return io.observe(el);
    const host = el.parentElement;
    if (!proxies.has(host)) proxies.set(host, []);
    proxies.get(host).push(el);
    io.observe(host);
  };
  const io = new IntersectionObserver(
    (entries) => {
      const shown = [];
      entries.filter((e) => e.isIntersecting).forEach((e) => {
        if (proxies.has(e.target)) {
          shown.push(...proxies.get(e.target));
          proxies.delete(e.target);
        } else shown.push(e.target);
      });
      shown.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top || a.getBoundingClientRect().left - b.getBoundingClientRect().left);
      shown.forEach((el, k) => {
        io.unobserve(el);
        if (el.matches(CLIPPED)) io.unobserve(el.parentElement);
        reveal(el, Math.min(k, 6) * STEP);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
  );

  function prepare(scope) {
    qsa(scope, SCOPE).concat(scope.matches && scope.matches(SCOPE) ? [scope] : []).forEach((sec) => {
      WORDS.forEach((s) =>
        qsa(sec, s).forEach((el) => {
          splitWords(el);
          el.classList.add('y-rv', 'y-rv-words');
        })
      );
      ITEMS.forEach((s) => qsa(sec, s).forEach((el) => el.classList.add('y-rv')));
      qsa(sec, '.y-rv:not(.is-in)').forEach((el) => {
        // Lo que está oculto (pestañas o ediciones inactivas) se revela al mostrarse
        if (el.closest('[hidden], .y-ed__slide:not(.is-active)')) return;
        watch(el);
      });
    });
  }

  /* ---- Pestañas y ediciones: lo nuevo entra escalonado ---- */
  function replay(container) {
    const els = qsa(container, '.y-rv');
    els.forEach((el) => {
      io.unobserve(el);
      el.classList.remove('is-in');
    });
    void container.offsetWidth;
    requestAnimationFrame(() => els.forEach((el, k) => reveal(el, Math.min(k, 8) * 80)));
  }
  const mo = new MutationObserver((muts) => {
    muts.forEach((m) => {
      const t = m.target;
      if (m.attributeName === 'hidden' && t.matches('.y-tabpanel') && !t.hidden) replay(t);
      if (m.attributeName === 'class' && t.matches('.y-ed__slide') && t.classList.contains('is-active') && m.oldValue && !m.oldValue.includes('is-active')) replay(t);
    });
  });

  /* ---- Franja en movimiento ---- */
  function marquee(strip) {
    if (strip.dataset.yMarquee) return;
    strip.dataset.yMarquee = '1';
    const text = strip.textContent.trim();
    const phrases = text.split(/\s*·\s*/).filter(Boolean);
    const sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = text;
    const track = document.createElement('div');
    track.className = 'y-marquee__track';
    track.setAttribute('aria-hidden', 'true');
    const half = () => phrases.map((p) => `<span>${p.replace(/</g, '&lt;')}</span>`).join('');
    track.innerHTML = half() + half();
    strip.textContent = '';
    strip.classList.add('y-strip--marquee');
    strip.append(sr, track);
    // Repite hasta cubrir el ancho y fija una velocidad constante (~45 px/s)
    const fit = () => {
      let guard = 0;
      while (track.scrollWidth / 2 < strip.clientWidth * 1.1 && guard++ < 6) track.innerHTML += half() + half();
      strip.style.setProperty('--y-mq-dur', `${Math.max(18, track.scrollWidth / 2 / 45)}s`);
    };
    fit();
    window.addEventListener('resize', fit, { passive: true });
  }

  /* ---- Parallax suave ---- */
  const hero = document.querySelector('.y-hero');
  const heroMedia = hero && hero.querySelector('.y-hero__media');
  const heroInner = hero && hero.querySelector('.y-hero__inner');
  const pImgs = qsa(document, '.y-why__img img, .y-bank__img img');
  pImgs.forEach((img) => (img.style.transform = 'scale(1.12)'));
  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      const vh = window.innerHeight;
      if (hero) {
        const r = hero.getBoundingClientRect();
        if (r.bottom > 0) {
          const s = Math.max(0, -r.top);
          const p = Math.min(1, s / r.height);
          heroMedia.style.transform = `translate3d(0, ${s * 0.32}px, 0)`;
          heroInner.style.transform = `translate3d(0, ${-s * 0.12}px, 0)`;
          heroInner.style.opacity = String(1 - p * 0.9);
        }
      }
      pImgs.forEach((img) => {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const k = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        img.style.transform = `translate3d(0, ${k * -5}%, 0) scale(1.12)`;
      });
    });
  }

  function init() {
    prepare(document);
    qsa(document, '.y-strip').forEach(marquee);
    qsa(document, '.y-tabpanel').forEach((p) => mo.observe(p, { attributes: true, attributeFilter: ['hidden'] }));
    qsa(document, '.y-ed__slide').forEach((s) => mo.observe(s, { attributes: true, attributeFilter: ['class'], attributeOldValue: true }));
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', (e) => prepare(e.target));
})();
